import {useLocation, useNavigate} from "react-router-dom";
import {Tooltip, Whisper} from "rsuite";
import {BsExclamationTriangleIcon} from "../../../models/Icons.model";

type FailuresHeaderActionProps = {
  className?: string;
};

// Значок «Сбои» в шапке (только администратор): сводка сбоев по всем станциям
const FailuresHeaderAction = ({className}: FailuresHeaderActionProps) => {
  const navigate = useNavigate();
  return (
    <Whisper speaker={<Tooltip>Сбои</Tooltip>}>
      <span className={className}>
        <BsExclamationTriangleIcon onClick={() => navigate("/failures")} className="users" />
      </span>
    </Whisper>
  );
};

// Пункт «Сбои» в мобильном меню
export const FailuresMenuItem = () => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  return (
    <li>
      <button
        type="button"
        onClick={() => navigate("/failures")}
        data-bs-dismiss="offcanvas"
        data-bs-target="#headerSidebarMenu"
        className={`btn tab-btn tab-action-btn ${pathname.startsWith("/failures") ? "active" : ""}`}
      >
        Сбои
      </button>
    </li>
  );
};

export default FailuresHeaderAction;
